import template from './ktable-settings.html';
import controller from './ktable-settings.controller';

import './ktable-settings.scss';

/**
 * @type {import('angular').IComponentOptions}
 */
const component = {
	template,
	bindings: {
		widget: '<',
		parent: '=',
	},
	transclude: true,
	controller,
};

export default component;
